import { Label } from "reactstrap";
import Select, { components } from "react-select";
import { useEffect, useMemo, useState } from "react";
import { TEMPLATE_URL } from "../../helpers/url_api_helper";

const normalizeTemplatesItems = (items) =>
  items.map((item) => ({
    value: item.id,
    label: item.title,
  }));
const TemplateSelect = ({ value, onChange, editable }) => {
  const [templates, setTemplates] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const CustomClear = (props) => (
    <components.ClearIndicator {...props}>
      <i
        className="fas fa-times"
        style={{ fontSize: "14px", color: "#888" }}
      />
    </components.ClearIndicator>
  );

  const customStyles = {
    singleValue: (base) => ({
      ...base,
      color: editable === true ? "#0576B960" : "#0576B9",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9599AD",
      fontWeight: "400",
    }),
    control: (base, state) => ({
      ...base,
      backgroundColor: state.hasValue ? "#EFF2F7" : "#FFF",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };  

  useEffect(() => {
    let isMounted = true;

    const fetchTemplates = async () => {
      setLoading(true);
      setError("");

      try {
        const templatesData = await TEMPLATE_URL.getTemplateAll();
        if (isMounted) {
          setTemplates(normalizeTemplatesItems(templatesData));
        }
      } catch (error) {
        if (isMounted) {
          setError("Error fetching templates");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchTemplates();
    return () => {
      isMounted = false;
    };
  }, []);

  const selectedValue = useMemo(() => {
    if (!value) return null;

    return templates.find(
      (template) => template.value === value.value
    ) || null;
  }, [value, templates]);

  return (
    <>
      <Label className="label-filter">Template</Label>

      <Select
        className="filter-select"
        components={{ ClearIndicator: CustomClear }}
        options={templates}
        value={selectedValue}
        onChange={onChange}
        placeholder={loading ? "Loading..." : "Select Template"}
        isClearable
        styles={customStyles}
        isDisabled={loading || editable}
        menuPortalTarget={document.body}
      />

      {error && <small className="text-danger">{error}</small>}
    </>
  );
};

export default TemplateSelect;
